"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("@material-ui/core/styles/makeStyles");
var checkboxStyles = makeStyles_1.default(function (_a) {
    var typography = _a.typography, palette = _a.palette;
    return ({
        root: {
            '&:hover': {
                backgroundColor: 'transparent',
            },
            width: '40px',
            height: '40px',
        },
        checkboxContainer: {
            display: 'flex',
            alignItems: 'center',
            fontSize: typography.fontSM,
        },
        checkboxesContainer: {
            display: 'flex',
            flexDirection: 'column',
        },
        errorMessage: {
            color: palette.error.main,
            fontSize: typography.fontXS,
            flexDirection: 'column',
            position: 'absolute',
            margin: '35px 0 0 10px',
        },
        label: {},
    });
}, { name: 'GqlCheckout_Checkboxes' });
exports.default = checkboxStyles;
